import { round } from 'es-toolkit';
import { isAxiosError } from 'axios';
import { t } from 'i18next';

import type { AlarmHistory } from '@/@types/alarm';

export interface ErrorInfo {
  statusCode: number;
  headerCode: string;
  bodyCode: string;
  commonMsgKey: string;
}

export function getErrInfo(err: any): ErrorInfo {
  let statusCode = -1;
  let headerCode = 'unKnown';
  let bodyCode = 'unKnown';
  let commonMsgKey: string = null;

  console.error('ERROR INFO ', err);

  if (isAxiosError(err)) {
    statusCode = err.status;
    headerCode = err.code;
    bodyCode = err.response.data.errorCode;
    switch (statusCode) {
      case 401:
        commonMsgKey = 'Logout.message.loginExpired';
        break;
      case 403:
        commonMsgKey = 'Common.message.Forbidden';
        break;
      case 404:
        commonMsgKey = 'Common.message.notFound';
        break;
      case 408:
        commonMsgKey = 'Common.message.timeOut';
        break;
      case 500:
        commonMsgKey = 'Common.message.serverErrorOccurred';
        break;
    }
  } else {
  }

  return {
    statusCode,
    headerCode,
    bodyCode,
    commonMsgKey,
  };
}

export function download(url: string) {
  const element = document.createElement('a');
  element.style.display = 'none';
  element.href = url;
  document.body.appendChild(element);

  element.click();
  document.body.removeChild(element);
}

export function compareInLowerCase(a: string, b: string) {
  if (typeof a !== 'string' || typeof b !== 'string') return false;
  return a.toLowerCase().includes(b.toLowerCase());
}

export function getTemperatureText(celsius: number | string, tempUnit: string, showUnit = false) {
  const tempNumber = tempUnit === 'CELSIUS' ? Number(celsius) : Number(celsius) * 1.8 + 32;
  const unitText = showUnit ? (tempUnit === 'CELSIUS' ? '℃' : '℉') : '';
  return round(tempNumber, 1) + unitText;
}

export function getThresholdText(history: AlarmHistory, tempUnit: string) {
  const { alarmType, threshold } = history;
  let [minText, maxText] = ['', ''];

  if (alarmType === 'Offline') {
    minText = threshold + t('Devices.label.minute');
  } else if (alarmType === 'Battery') {
    minText = threshold + '%';
  } else if (alarmType === 'Temperature') {
    const { min, max } = threshold;
    minText = getTemperatureText(min, tempUnit, true);
    maxText = getTemperatureText(max, tempUnit, true);
  } else if (alarmType === 'Humidity') {
    const { min, max } = threshold;
    minText = min + '%';
    maxText = max + '%';
  }

  return maxText !== '' ? `${minText} ~ ${maxText}` : minText;
}
